class MessageParser {
  constructor(actionProvider, state) {
    this.actionProvider = actionProvider;
    this.state = state;
  }

  parse(message) {
    console.log(message);
  }

  parse(message) {
    if (message.includes("hello") || message.includes("hi")) {
      this.actionProvider.handleHello();
    }
    if (message.includes("how are") || message.includes("how you")) {
      this.actionProvider.handleHowAreYou();
    }
    if (message.includes("facts") || message.includes("skills")) {
      this.actionProvider.handleSkills();
    }
    if (message.includes("education") || message.includes("degree")) {
      this.actionProvider.handleEdu();
    }
    if (message.includes("exprience")) {
      this.actionProvider.handleExp();
    }
    if (message.includes("gandu") || message.includes("bsdk")) {
      this.actionProvider.handleGali();
    }
  }
}

export default MessageParser;
